// src/components/dashboards/DashboardGround.tsx
// ---------------------------------------------------------------------------
// The dashboard's page ground: the supplied artwork under an elliptical veil.
//
// The veil is an ELLIPSE, not a flat wash. The content column lives in the
// middle, so the middle is darkened hardest and the veil thins toward the left
// and right edges where the artwork's blobs are. That keeps the artwork doing
// what it is good at (framing) and keeps it off the data.
//
// The centre is held FLAT at VEIL_CENTRE out to 52% and only then falls away.
// A veil that starts thinning immediately still left blob shapes drifting
// behind the charts; the content column wants plain navy under it, and all the
// interest belongs outside it.
//
// This used to be one of two grounds (the other a plain deepNavy -> royalBlue
// gradient), chosen by the ?dash toggle. The toggle is gone.
// ---------------------------------------------------------------------------

import { Box, alpha } from "@mui/material";
import { athenaColors } from "../../theme/palette";

/** Supplied artwork. Swap the file to change the ground. */
export const DASHBOARD_BG = "/images/landing/dashboard_bg.jpg";
/** Overlay alpha through the middle, and out at the left/right edges. */
const VEIL_CENTRE = 0.97;
const VEIL_EDGE = 0.1;

export default function DashboardGround() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        overflow: "hidden",
        backgroundColor: athenaColors.deepNavy,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${DASHBOARD_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `radial-gradient(ellipse 78% 135% at 50% 50%, ${alpha(
            athenaColors.deepNavy,
            VEIL_CENTRE
          )} 0%, ${alpha(athenaColors.deepNavy, VEIL_CENTRE)} 52%, ${alpha(
            athenaColors.deepNavy,
            VEIL_CENTRE * 0.7
          )} 76%, ${alpha(athenaColors.deepNavy, VEIL_EDGE)} 100%)`,
        }}
      />
    </Box>
  );
}
